import { AccordionContext } from './accordion/accordion.context';
import { AccordionElement } from './accordion/accordion';
import { AccordionSlideElement } from './accordion-slide/accordion-slide';
import { AccordionTabElement } from './accordion-tab/accordion-tab';
import { MobileMenuButtonElement } from './mobile-menu-button';

// Slider
import './slider';
import './slider-slide';
import './slider-slides';
import './slider-pagination';

// Accordion
(function () {
  customElements.define(
    'eo-internal-accordion-provider',
    // @ts-ignore
    AccordionContext.Provider
  );

  customElements.define(
    'eo-accordion',
    // @ts-ignore
    AccordionElement
  );

  customElements.define(
    'eo-accordion-slide',
    // @ts-ignore
    AccordionSlideElement
  );

  customElements.define(
    'eo-accordion-tab',
    // @ts-ignore
    AccordionTabElement
  );

  customElements.define(
    'eo-mobile-menu-button',
    // @ts-ignore
    MobileMenuButtonElement
  );
})();
